import { IframeAdapter } from "@web-monorepo/realtime/toolkit-iframe";
import { isDisplay, isRemote, mountPoint } from "./util/role";

const isEmbeddedInTeach = (isRemote && mountPoint === "teach") || isDisplay;
const hasPostMessageCapability = !!(
  typeof window === "object" &&
  // @ts-expect-error ts(2774) Extra safety-check for toolkit, just in case. "This condition will always return true since this function is always defined."
  window.postMessage &&
  window !== window.parent &&
  window.parent.postMessage
);

const params = new URLSearchParams(typeof window !== "undefined" ? window.location.search : undefined);
const parentOrigin = params.get("parentOrigin") || undefined;

export const isStandaloneMode = !isEmbeddedInTeach || !hasPostMessageCapability;

// When teach embeds toolkit with `iframeOnly=1`, toolkit must not open its own
// NATS connection. All realtime traffic flows over the iframe postMessage bridge,
// with teach acting as the NATS <-> postMessage relay. Only meaningful when embedded
// in teach — standalone (mobile remote / display) always needs its own NATS link.
export const iframeNatsDisabled = params.get("iframeOnly") === "1" && !isStandaloneMode;

export default function getIframeAdapter(): IframeAdapter | null {
  if (isEmbeddedInTeach && hasPostMessageCapability) {
    return new IframeAdapter(window, window.parent, parentOrigin);
  }
  return null;
}
